import classNames from "classnames"
import React, { useEffect, useRef } from "react"

import "./Popover.scss"

type PointSide = "top" | "bottom" | "left" | "right"

type PopoverProps = {
  children: React.ReactNode
  shown?: boolean
  point?: PointSide
  className?: string
  onDismiss?: () => void
  triggerRef?: React.RefObject<Element | null>
}

function Popover({
  children,
  shown = true,
  point,
  className,
  onDismiss,
  triggerRef,
}: PopoverProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!shown || !onDismiss) return

    const handleOutsideClick = (e: MouseEvent) => {
      const target = e.target as Node
      if (ref.current?.contains(target)) return
      if (triggerRef?.current?.contains(target)) return
      onDismiss()
    }

    document.addEventListener("mousedown", handleOutsideClick)
    return () => document.removeEventListener("mousedown", handleOutsideClick)
  }, [shown, onDismiss, triggerRef])

  return (
    <div
      ref={ref}
      className={classNames("Popover__container", className, {
        "Popover__container--hidden": !shown,
      })}
    >
      <div
        className={classNames("Popover", {
          [`Popover--point-${point}`]: point,
          "Popover--hidden": !shown,
        })}
      >
        {children}
      </div>
    </div>
  )
}

export default Popover
